export default __webpack_public_path__ + "static/media/hand.4d8fbe91.png";